import type { AppStore } from './store';

// Plain (non-React) access to the single Redux store instance, the same non-circular pattern as
// msalInstance.ts's getMsalInstance/setMsalInstance. emptyApi.ts needs to dispatch logout() when
// silent token renewal fails outright, but importing `store` directly from store.ts creates a
// real circular module dependency (store.ts -> kantoordagApi.ts -> emptyApi.ts -> store.ts) that
// breaks at runtime under Rollup's production bundling - `combineSlices(...)` in store.ts sees
// `kantoordagApi` as undefined ("Cannot use 'in' operator to search for 'reducerPath' in
// undefined"), crashing the whole app on load. `yarn build`/`yarn lint` don't catch this (they
// check types/lint rules, not bundled runtime behaviour) - only caught live on staging. This
// module has no dependency on store.ts (only a type-only import, erased at build time), so it
// can't be part of any cycle.
let instance: AppStore | undefined;

export function setStoreInstance(store: AppStore) {
    instance = store;
}

export function getStoreInstance(): AppStore | undefined {
    return instance;
}
